import { HStack } from '@chakra-ui/react';
import React from 'react';
import { LuChevronRight } from 'react-icons/lu';

import StatWithChange from './stats-with-change';

const QueueStats: React.FC<{
  setIsServiceQueueOpen: (isServiceQueueOpen: boolean) => void
  isServiceQueueOpen: boolean
  data: {
    count: number
    averageWaitTimeInMinutes: string
  }
}> = ({
  setIsServiceQueueOpen,
  isServiceQueueOpen,
  data,
}) => {
  const { count, averageWaitTimeInMinutes } = data;
  return (
    <HStack
      role="button"
      borderTop="1px solid"
      borderColor="border"
      alignItems="center"
      p="4"
      justifyContent="space-between"
      _hover={{ backgroundColor: 'var(--chakra-colors-bg-subtle)' }}
      cursor="pointer"
      onClick={() => setIsServiceQueueOpen(!isServiceQueueOpen)}
    >
      <StatWithChange
        label="Cases in queue"
        value={count}
      />
      <StatWithChange
        label="Average wait"
        value={averageWaitTimeInMinutes}
        unit="min"
      />
      <LuChevronRight data-testid="chevron-icon" size="24px" />
    </HStack>
  );
};

export default QueueStats;
